export function isHeicFile(file: File): boolean {
  return file.type === 'image/heic' || file.type === 'image/heif' || /\.(heic|heif)$/i.test(file.name);
}

export async function convertHeicToPng(file: File): Promise<File> {
  const { heicTo } = await import('heic-to');
  const blob = await heicTo({ blob: file, type: 'image/png' });
  const name = file.name.replace(/\.(heic|heif)$/i, '.png');
  return new File([blob], name, { type: 'image/png' });
}
